module.exports = __webpack_public_path__ + "static/soc2-6c6c5d9d02feab1ca45f5c710d7c600e.png";